import {useSelector} from "react-redux";

const useAnimalDetails = () => {
    return useSelector(state => state.case_one.animal_details);
};

export default useAnimalDetails;
